import { render, staticRenderFns } from "./application_item_dialog.vue?vue&type=template&id=8de23edc"
import script from "./application_item_dialog.vue?vue&type=script&lang=js"
export * from "./application_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./application_item_dialog.vue?vue&type=style&index=0&id=8de23edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports